// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__ySwWs","cardText":"Card_cardText__CqJ8e","description":"Card_description__gii1L","readMore":"Card_readMore__V8zTK"};